import React, { useEffect, useState, useRef,useMemo } from 'react'
import { Link } from 'react-router-dom'
import './Header.css'
import logo from '../../images/FDNY.png';
import { getUserDetails } from "../../actions"
import { useDispatch, useSelector } from 'react-redux'
import { MdMenu } from 'react-icons/md';
import { Menu } from 'primereact/menu';
import { Sidebar } from 'primereact/sidebar';
import { useLocation, useHistory } from "react-router-dom";
import { FadeInDiv } from '../Animations'
import {GLOBAL_TIME_MINS,LOGOUT_TIME_MINS,COUNT_DOWN_SECS,CURRENT_HOST} from '../../constants'
import utils from '../../utils'

const Header = () => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.userReducers)
  const [visible, setVisible] = useState(false)

  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  //const [origin,setOrigin] = useState('')
  useEffect(() => {
    history.listen((location, action) => {
      setVisible(false)
    })
    if(window.location.href.indexOf("/auth")>-1){
      dispatch(getUserDetails({}))
    }
    return () => {
    }
  }, [dispatch, history])

  
  useEffect(() => {
    const handler = () => {
      if (window.innerWidth > 1260) {
        setVisible(false)
      }
    }
    window.addEventListener('resize', handler)

    //setOrigin(window.location.origin)
    // Remove event listener on cleanup
    return () => {
      window.removeEventListener('resize', handler)
    }
  }, [])

  
  const menu = useRef()
  var items = useMemo(()=>{ return [{label:"Logout",command:()=>{ 
    
   // utils.logout() 
   flagToLogout()
  
  },icon:"pi pi-sign-out"}]},[])


  useEffect(()=>{

    //Remove per discussion with team, Bo suggest to open a new tab for the account management.
    // if(window.location.href.indexOf('/auth')>-1){
    //   var label = "Back"
    //   var queryParams = new URLSearchParams(window.location.search)
    //   var backbtnurl = queryParams.get("backbtnurl")
    //   var appname_param = queryParams.get("appname")
    //   if (backbtnurl !== null && backbtnurl !== '') {
    //       window.sessionStorage.setItem('backbtnurl',backbtnurl)
    //   }else{
    //     if(window.sessionStorage.getItem('backbtnurl')){
    //       backbtnurl = window.sessionStorage.getItem('backbtnurl')
    //     }
    //   }
    //   if (appname_param !== null && appname_param !== '') {
    //     window.sessionStorage.setItem('appname_param',appname_param)
    //     label += ` to ${appname_param}`
    //   }else{
    //     if(window.sessionStorage.getItem('appname_param')){
    //       appname_param = window.sessionStorage.getItem('appname_param')
    //       label += ` to ${appname_param}`
    //     }
    //   }
    //   if(backbtnurl!==null&&backbtnurl!==''){
    //     items.push({label:label,command:()=>{ 
    //       window.sessionStorage.removeItem('backbtnurl')
    //       window.sessionStorage.removeItem('appname_param')
    //       window.location.href = backbtnurl;
    //   },icon:""})
    //   }
    // }

    return ()=>{
    }
  },[items])

  const flagToLogout = ()=>{
    var date = new Date();
    date.setTime(date.getTime() + (LOGOUT_TIME_MINS * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
    document.cookie = "f" + "=" + "true" + expires + "; path=/; secure; domain=" + CURRENT_HOST;
  }

  const navigateToHome= ()=>{
    window.location.href = "/accountmanagement/auth/my-profile"
  }
  return splitLocation[1] === 'unauth' ?
    <div className="nav-header">
      <nav>

        <div className="expand-menu">
          {/* <FadeInDiv>
            <MdMenu size={28} color="white" onClick={() => {
              const toggleVisible = !visible;
              setVisible(toggleVisible)
            }} />
          </FadeInDiv> */}
        </div>
        <div className="expand-menu-placeholder"></div>
        <div><img src={logo} alt="logo" className={`app-logo ${splitLocation[2] === "activate-account" ? '' : (splitLocation[2] === "password-reset" ? '' : (splitLocation[2] === "" ?  "" : "hovercursor"))}`} onClick={()=>{
          let val = `${splitLocation[2] === "activate-account" ? '' : (splitLocation[2] === "password-reset" ? '' : (splitLocation[2] === "" ?  "" : "hovercursor"))}`
          if(val==="hovercursor"){
            navigateToHome()
          }
        }}/></div>
        <div className={`header-title-container ${splitLocation[2] === "activate-account" ? '' : (splitLocation[2] === "password-reset" ? '' : (splitLocation[2] === "" ?  "" : "hovercursor"))}`} onClick={()=>{
          let val = `${splitLocation[2] === "activate-account" ? '' : (splitLocation[2] === "password-reset" ? '' : (splitLocation[2] === "" ?  "" : "hovercursor"))}`
          if(val==="hovercursor"){
            navigateToHome()
          }
        }}>
          <div className="header-title">{splitLocation[2] === "activate-account" ? 'Activate Single Sign On' : (splitLocation[2] === "password-reset" ? 'Password Reset' : (splitLocation[2] === "faqs" ?  "Login FAQs" : "Account Management"))}</div>
        </div>
      </nav>
    </div>
    : <div className="nav-header">
      <nav>
        <div className="expand-menu">
          <FadeInDiv>
            <MdMenu size={28} color="white" onClick={() => {
              const toggleVisible = !visible;
              setVisible(toggleVisible)
            }} />
          </FadeInDiv>
        </div>
        <div className="expand-menu-placeholder"></div>
        <div><img src={logo} alt="logo" className="app-logo hovercursor" onClick={()=>{
          navigateToHome()
        }}/></div>
        <div className="header-title-container hovercursor" onClick={()=>{
          navigateToHome()
        }}>
          <div className="header-title">Account Management</div>
        </div>
        <div className="hide-on-expand">
          {/* <FadeInDiv>
            <ul>
              <li>
                <Link className={splitLocation[2] === "my-profile" ? "active" : ""} to="/auth/my-profile">My Profile</Link>
              </li>
              <li>
                <Link className={splitLocation[2] === "change-password" ? "active" : ""} to="/auth/change-password">Change Password</Link>
              </li>
              <li>
                <Link className={splitLocation[2] === "multi-factor-auth" ? "active" : ""} to="/auth/multi-factor-auth">2-Step Verification</Link>
              </li>
              <li>
                <Link className={splitLocation[2] === "security-question" ? "active" : ""} to="/auth/security-question">Security Questions</Link>
              </li>
            </ul>
          </FadeInDiv> */}
        </div>
        <Sidebar visible={visible} onHide={() => setVisible(false)}>
          <div className="side-bar">
            <div className="side-bar-title">Account Management</div>
            <div className="side-bar-item"><Link className={splitLocation[2] === "my-profile" ? "active" : ""} to="/auth/my-profile">Account Management Home</Link></div>
            <div className="side-bar-item-divider"></div>
            <div className="side-bar-item"><Link className={splitLocation[2] === "change-password" ? "active" : ""} to="/auth/change-password">Change Password</Link></div>
            <div className="side-bar-item-divider"></div>
            <div className="side-bar-item"><a href={`${window.location.origin}/accountmanagementmfa/oauth2/authorization/oracle`}>2-Step Verification</a></div>
            <div className="side-bar-item-divider"></div>
            <div className="side-bar-item"><Link className={splitLocation[2] === "security-question" ? "active" : ""} to="/auth/security-question">Security Questions</Link></div>
            <div className="side-bar-item-divider"></div>
            <div className="side-bar-item"><Link className={splitLocation[2] === "faqsauth" ? "active" : ""} to="/auth/faqsauth">FAQs</Link></div>
          </div>
        </Sidebar>

        <Menu model={items} popup ref={menu}/>
        {window.location.href ? !(window.location.href.indexOf('public') >-1) ?  <>
      {user.data.displayName ? <div className="hide-on-small-device login-display"  onClick={(event)=>{
        menu.current.toggle(event)
      }}><i className="pi pi-user"></i>&nbsp;&nbsp;{user.data.displayName}&nbsp;&nbsp;<i className="menu-arrow pi pi-chevron-down"></i></div> :
        
        <div className="hide-on-small-device login-display"><a href="/accountmanagement/login.html">Login</a></div>
      }

      {user.data.displayName ? <div className="show-on-small-device login-display" onClick={(event)=>{
        menu.current.toggle(event)
      }} ><i className="pi pi-user"></i></div> :
        <div className="show-on-small-device login-display"><a href="/accountmanagement/login.html">Login</a></div>
      }
      </>:null:null}

      </nav>
    </div>
}

export default Header;